<template>
  <div>
    <div class="input-group mb-0 d-flex flex-row justify-content-between p2">
      <h4 class="card-title mb-0">Archive</h4>
      <router-link v-show="showAddBtn" :to="{ name: 'add-archive' }" type="button" class="btn btn-primary mr-3">Add New</router-link>
    </div>


    <div class="table-responsive">

      
  
      <!-- All -->
      <table
        id="archives_tbl"
        class="display table table-striped table-bordered"
        style="width:100%;">
        <thead>
          <tr>
            <th>No</th>
            <th>Content</th>
            <th>Date</th>
            <th>Link</th>
            <th>For</th>
            <th width="10">Action</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(archive, index) in archives" :key="index">
            <td>{{ (index + 1) }}</td>
            <td>{{ archive.title }}</td>
            <td>{{ archive.date }}</td>
            <td>{{ archive.link }}</td>
            <td>
              {{ archive.visible_to.map(item => item.name).join(', ') }}
            </td>
            <td>
              <router-link
                :to="goTo(archive.id)"
                type="button"
                class="btn btn-success btn-rounded btn-block"
                >Edit Details</router-link
              >
            </td>
          </tr>
        </tbody>
      </table>
    </div>

  </div>
</template>

<script>
// @ is an alias to /src
import axios from "axios";
import Pagination from "vue-pagination-2";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import JsonExcel from "vue-json-excel";
import { getRequest, postRequest } from "@/services/RequestService";
import { jsPDF } from "jspdf";
import autoTable from 'jspdf-autotable';
import CKEditor from "@ckeditor/ckeditor5-vue";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import AddWebinar from "./add.vue";
import { getArchives } from "@/services/WebinarService";

export default {
  name: "award-points",
  components: { Pagination, JsonExcel, ckeditor: CKEditor.component, AddWebinar },

  data() {
    return {
      editor: ClassicEditor,
      editorConfig: {},
      content: "",


      reject_remarks: null,
      awardPoint: 0,
      awardId: null,

      archives: [],

      showAddBtn: false,
      
    };
  },

  methods: {
    async fetchArchives() {
      try {
        const response = await getArchives();
        if(response.data.success) {
          this.archives = response.data.data;
        }
        this.showAddBtn = this.archives.length < 5 ? true : false;

      } catch (e) {
        console.log(e)
      }
    },

    hideModal(name) {
      $(name).modal('hide');
    },

    setDatatable() {
      this.loadTable("#archives_tbl");
    },

    destroyDataTables() {
      this.destroyDataTable("#archives_tbl");
    },

    loadTable(id) {
      $(id).DataTable({
        pageLength: 5,
        dom: "Bfrtip",
        buttons: [
          {
            extend: "excelHtml5",
            exportOptions: {
              columns: ':not(:last-child)',
            }
          },
          {
            extend: "pdfHtml5",
            orientation: 'landscape',
            pageSize: 'LEGAL',
            exportOptions: {
              columns: ':not(:last-child)',
            }
          }
        ]
      });
    },

    goTo(id) {
      return `/marketing/archive/edit/${id}`;
    },
  },

  async created() {
    await this.fetchArchives();
    await this.setDatatable();

    const column2 = document.getElementById('archives_tbl_filter');
    const newDiv = document.createElement(`div`);
    newDiv.classList.add('new-div-class', 'float-left', 'text-danger', 'mb-0');
    newDiv.textContent = 'Note: Maximum of 5 archives only';
    column2.appendChild(newDiv);
  },

};
</script>

<style>
.change-background {
  background-color: #5f5f5f;
  color: white;
}


</style>
